import './listing.scss';
import Glide from '@glidejs/glide'

(($) => {
    function initListingEtablissements() {

        const ehpad = document.querySelector(".glide.ehpad")

        if(ehpad) {
            let glide = new Glide(ehpad, {
                type: 'carousel',
                // autoplay: 3000,
                perView: 4,
                gap: 0,   
                breakpoints: {
                    1400: {
                        perView: 3
                    },
                    1100: {
                        perView: 2
                    },
                    767: {
                        perView: 1
                    },
                } 
            })
            
            glide.mount()
        }

    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initListingEtablissements", initListingEtablissements);
    } else {
        $(document).ready(initListingEtablissements);
    }
})(jQuery);